import React from 'react';
import { ButtonClean, Dropdown, Icon, ToolbarButton, Tooltip, useCopyToClipboard, } from '@fourthwall/components';
import { DotsHorizontalIcon, DuplicateIcon, TickIcon } from '@fourthwall/icons';
import * as S from './PublicTokenListItem.styled';
export const PublicTokenListItem = ({ token, onDelete }) => {
    const { isCopied, copyToClipboard } = useCopyToClipboard();
    return (React.createElement(S.Container, null,
        React.createElement(S.TokenContainer, null,
            React.createElement("div", null, token),
            React.createElement("div", null, isCopied ? (React.createElement(Tooltip, { reference: React.createElement(Icon, { component: TickIcon, height: 12 }) }, "Copied!")) : (React.createElement(Tooltip, { reference: React.createElement(ButtonClean, { label: "", icon: DuplicateIcon, onClick: () => copyToClipboard(token) }) }, "Copy")))),
        React.createElement(Dropdown, { content: React.createElement(Dropdown.Item, { label: "Remove", onClick: () => onDelete(token) }), position: "bottom-end" },
            React.createElement(ToolbarButton, { icon: DotsHorizontalIcon }))));
};
